
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessibility-policy",
      function () {
        return require("private-next-pages/accessibility-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessibility-policy"])
      });
    }
  